import {MainBreakoutRoomId} from '../constants';
import type {BreakoutParticipants} from '../types';

export const getBreakoutRooms = (participants: BreakoutParticipants) =>
    Array.from(participants.keys()).filter(key => key !== MainBreakoutRoomId);
